/* ============================================================
   PHREED SECTION DESIGN SYSTEM — scroll-in animation observer
   ============================================================
   Paired with phreed-section-system.css.

   Watches every element with [data-phreed-animate] and toggles
   .is-in-view when the element enters the viewport. The CSS does
   the actual fade + slide-up.

   - Uses IntersectionObserver (supported everywhere modern; older
     browsers fall back to showing everything immediately).
   - Respects prefers-reduced-motion at the CSS level — no JS needed.
   - Re-scans on Shopify's `shopify:section:load` event so newly
     added sections animate correctly in the Theme Editor preview.
   - Unobserves elements after their first reveal (one-shot).
   ============================================================ */

(function () {
  'use strict';

  var SELECTOR = '[data-phreed-animate]:not(.is-in-view)';

  // Fallback for very old browsers — reveal everything synchronously.
  if (typeof window.IntersectionObserver === 'undefined') {
    document.querySelectorAll('[data-phreed-animate]').forEach(function (el) {
      el.classList.add('is-in-view');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      // Start animating slightly before the element fully enters view,
      // so it's already part-way through its animation when the user reads it.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.05,
    }
  );

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      observer.observe(el);
    });
  }

  // Initial scan — run as soon as DOM is parsed.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Theme Editor: re-scan whenever a section is added or reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
